<template>
    <div class="settings-extracts">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Extrato</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <!-- Filtro -->
        <div class="filter is-center">
            <mu-select v-model="month">
                <mu-option v-for="(item, key) in months" :key="key" :label="getMonth(item)" :value="item"></mu-option>
            </mu-select>
            <mu-select v-model="year">
                <mu-option v-for="(item, key) in years" :key="key" :label="`${item}`" :value="item"></mu-option>
            </mu-select>
            <mu-button @click="loadExtract()" color="secondary" round>Ok</mu-button>
        </div>

        <!-- Balance -->
        <div class="extract" v-if="(company.signatureType == 'T' || company.signatureType == 'P') && !balance.loading">
            <h4 class="is-center">Saldo dos serviços contratados</h4>
            <table class="mu-table-custom">
                <thead>
                    <tr>
                        <th>Serviço</th>
                        <th class="is-center">Quantidade</th>
                        <th class="is-center">Saldo</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, key) in balance.list" :key="key">
                        <td>{{ item.name }}</td>
                        <td class="is-center">{{ item.balance }}</td>
                        <td class="is-center">{{ priceFormat(item.balance * item.tax, 4) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Loading Balance -->
        <mu-loading text="Aguarde... Carregando os dados do saldo." v-if="balance.loading"></mu-loading>

        <!-- Extract -->
        <div class="extract" v-if="!extract.loading">
            <h4 class="is-center">{{ title }}</h4>
            <table class="mu-table-custom">
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Descrição</th>
                        <th class="is-center">Quantidade</th>
                        <th class="is-center">Serviço</th>
                        <th class="is-right">Valor (R$)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, key) in extract.list" :key="key">
                        <td class="col_date">{{ dateFormat(item.created_at, false) }}</td>
                        <td class="col_description">{{ getDescription(item) }}</td>
                        <td class="col_quantity is-center">{{ item.quantity }}</td>
                        <td class="col_service is-center">{{ item.services.name }}</td>
                        <td class="col_value is-right" v-bind:class="{ 'col_debit': item.transaction_type === 'D', 'col_reverse': item.transaction_type === 'E'}">{{ priceFormat(item.amount, 4) }} {{ item.transaction_type }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="is-center legend">
                C = Crédito <span class="col_debit">D = Débito</span> <span class="col_reverse">E = Estorno</span>
            </div>
            <div class="is-center download">
                <mu-button @click="download()" color="primary" round>
                     <font-awesome-icon icon="file-download" class="icon-md icon-margin-left"/>
                     Download
                </mu-button>
            </div>
        </div>

        <!-- Loading Extract -->
        <mu-loading text="Aguarde... Carregando os dados do extrato." v-if="extract.loading"></mu-loading>

    </div>
</template>

<script>
    import ExtractsServices from '@/services/settings/extracts'
    import BalanceServices from '@/services/dashboards/balance'
    import jsreport from 'jsreport-browser-client-dist'
    import moment from 'moment'

    export default {
        name: 'app-settings-extract',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                year: 0,
                month: 0,
                months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                years: [],
                title: '',
                breadcrumbs: [
                    {
                        text: 'Configurações',
                        route: 'app.settings',
                        disabled: false
                    },
                    {
                        text: 'Extrato',
                        disabled: true
                    }
                ],
                extract: {
                    loading: false,
                    list: []
                },
                balance: {
                    loading: false,
                    list: []
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {
            company () {
                return this.$store.state.company
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        async created () {
            let date = new Date()
            this.month = date.getMonth() + 1
            this.year = date.getFullYear()

            for (let index = this.year; index >= 2019; index--) {
                this.years.push(index)
            }
            this.loadExtract()
            this.loadBalance()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Método responsável por carregar a listagem de palavras chaves
             */
            async loadExtract () {
                try {
                    this.extract.loading = true
                    this.extract.list = []

                    let result = await ExtractsServices.find({
                        month: this.month,
                        year: this.year
                    })

                    this.title = `Extrato ${this.getMonth(this.month)} / ${this.year}`

                    if (result && result.status) {
                        this.extract.list = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar o extrato.')
                } finally {
                    this.extract.loading = false
                }
            },

            /**
             * Carrega o saldo do cliente
             */
            async loadBalance () {
                try {
                    this.balance.loading = true

                    let result = await BalanceServices.balances()

                    if (result && result.status) {
                        this.balance.list = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar o saldo.')
                } finally {
                    this.balance.loading = false
                }
            },

            /**
             * Verificar qual é o título a mostrar para o item do extrato
             */
            getDescription (item) {
                if (item.transaction_type === 'C') {
                    return `CRÉDITO`
                } else if (item.transaction_type === 'D') {
                    return `DÉBITO`
                } else if (item.transaction_type === 'E') {
                    return `ESTORNO`
                }
                return '-'
            },

            async download () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde... Processando o extrato.')

                    if (!process.env.VUE_APP_JSREPORT_HOST) {
                        this.$eventHub.$emit('snackbar', 'error', 'Não foi possível gerar o extrato.')
                    }

                    let authBasicBase64 = Buffer.from(`${process.env.VUE_APP_JSREPORT_USER}:${process.env.VUE_APP_JSREPORT_PASSWORD}`).toString('base64')

                    let extract = this.extract.list.map((item) => {
                        return {
                            created: this.dateFormat(item.created_at, false),
                            description: this.getDescription(item),
                            quantity: item.quantity,
                            service: item.services.name,
                            price: this.priceFormat(item.amount, 4) + ' ' + item.transaction_type
                        }
                    })

                    jsreport.headers['Authorization'] = 'Basic ' + authBasicBase64
                    jsreport.serverUrl = process.env.VUE_APP_JSREPORT_HOST
                    jsreport.renderAsync({
                        template: {
                            name: 'balances-pdf'
                        },
                        data: {
                            title: `Extrato ${this.getMonth(this.month)} de ${this.year}`,
                            company: this.company.name,
                            extract: extract
                        }
                    }).then((res) => {
                        this.$eventHub.$emit('loading', false)
                        res.download(`extrato-${moment().format('YYYY-MM-DD-HH-mm-ss')}.pdf`)
                    }).catch(() => {
                        this.$eventHub.$emit('loading', false)
                        this.$eventHub.$emit('snackbar', 'error', 'Ocorreu um problema ao gerar o extrato.')
                    })
                } catch (e) {
                    this.$eventHub.$emit('loading', false)
                    this.$eventHub.$emit('snackbar', 'error', 'Ocorreu um problema ao gerar o extrato..')
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../../assets/stylus/bootstrap.styl'

    .settings-extracts

        .filter
            .mu-input
                margin-right 15px

        .extract
            margin auto
            max-width 700px

            .download
                padding 20px 0

            .legend
                padding 10px 0
                span
                    padding-left 15px

            .col_date
                width 100px

            .col_service
                width 100px

            .col_value
                width 100px

            .col_debit
                color $red

            .col_reverse
                color $orange

            table
                width 100%
                text-align left
                border-spacing 0

                th, td
                    padding 2px 4px
                    color #333

                thead
                    tr
                        th
                            background #c0c0c0
                            border-top 1px #818181 solid
                            border-bottom 1px #818181 solid
                            vertical-align middle

                tbody
                    tr
                        td
                            border-bottom 1px #c0c0c0 solid
                            vertical-align middle
                        &:nth-child(even)
                            td
                                background #e3e3e3

</style>
